import React, { useContext } from "react";
import clsx from "clsx";
import loadable from "@loadable/component";
import PageContext from "@PageContext";
import ReactLink from "@micado-digital/react-link/ReactLink";

import styles from "./Footermenu.styles";

const Typography = loadable(() => import("@micado-digital/react-ui/components/Typography"));

const Footermenu = () => {
	const css = styles();
	const [pageData] = useContext(PageContext);
	const { menuGroups } = pageData;
	const footermenuGroup = menuGroups?.find(menuGroup => menuGroup?.title === "Footermenü");

	return (
		<div className={clsx(css.footermenu, "mco-view-component-footer-footermenu")}>
			{footermenuGroup?.items?.map(item => {
				const { id, items, link, linkRel, selected, target, title } = item;
				return (
					<div key={id}>
						<ReactLink
							className={clsx(
								css.mainLink,
								"mco-view-component-footer-footermenu__main-link",
								{
									[css.mainLinkSelected]: selected,
									"mco-view-component-footer-footermenu__main-link--selected": selected
								}
							)}
							rel={linkRel}
							target={target}
							to={link}
						>
							<Typography className={css.socialIconsTitle} variant="label-medium">
								{title}
							</Typography>
						</ReactLink>
						{items?.map(subitem => {
							const {
								id: subid,
								link: subLink,
								rel: subRel,
								selected: subSelected,
								target: subTarget,
								title: subTitle
							} = subitem;

							return (
								<div key={subid}>
									<ReactLink
										className={clsx(
											css.subLink,
											"mco-view-component-footer-footermenu__sub-link",
											{
												[css.subLinkSelected]: subSelected,
												"mco-view-component-footer-footermenu__sub-link--selected": subSelected
											}
										)}
										rel={subRel}
										target={subTarget}
										to={subLink}
									>
										<Typography className={css.socialIconsTitle} variant="label-small">
											{subTitle}
										</Typography>
									</ReactLink>
								</div>
							);
						})}
					</div>
				);
			})}
		</div>
	);
};

export default Footermenu;
